export const STANDARD_PACKAGE_TYPE_NAMES = {
  MICRO: "Micro",
  SMALL: "Small",
  MEDIUM: "Medium",
  LARGE: "Large",
  CUSTOM: "Custom",
  PALLET: "Pallet",
  POSTAL: "Postal"
};

export const PACKAGE_TYPE_CSV_COLUMNS = {
  [STANDARD_PACKAGE_TYPE_NAMES.MICRO]: "Total Micro Packages",
  [STANDARD_PACKAGE_TYPE_NAMES.SMALL]: "Total Small Packages",
  [STANDARD_PACKAGE_TYPE_NAMES.MEDIUM]: "Total Medium Packages",
  [STANDARD_PACKAGE_TYPE_NAMES.LARGE]: "Total Large Packages",
  [STANDARD_PACKAGE_TYPE_NAMES.CUSTOM]: "Total Other Packages",
  [STANDARD_PACKAGE_TYPE_NAMES.PALLET]: "Total Pallet Packages",
  [STANDARD_PACKAGE_TYPE_NAMES.POSTAL]: "Total Postal Packages"
};
